// Admin panel article / editor operations. Everything is saved into public/data (see codeDataStore.js).
import { getJournals, saveLocalJournals, getExecutiveEditors, saveLocalEditors } from './firebaseService';

// Journal operations
export const journalService = {
  // Get all journals
  getAllJournals: async () => getJournals(),

  // Add new journal
  addJournal: async (journalData) => {
    const current = await getJournals();
    const newEntry = {
      id: 'journal_' + Date.now(),
      ...journalData,
      date: journalData.date || new Date().toISOString().split('T')[0],
      createdAt: new Date().toISOString()
    };
    await saveLocalJournals([newEntry, ...current]);
    return newEntry;
  },

  // Update journal
  updateJournal: async (id, journalData) => {
    const current = await getJournals();
    const updated = current.map(item => item.id === id ? { ...item, ...journalData, updatedAt: new Date().toISOString() } : item);
    await saveLocalJournals(updated);
    return { id, ...journalData };
  },

  // Delete journal
  deleteJournal: async (id) => {
    const current = await getJournals();
    await saveLocalJournals(current.filter(item => item.id !== id));
    return { id };
  }
};

// Executive Editors operations
export const executiveEditorService = {
  getAllEditors: async () => getExecutiveEditors(),

  addEditor: async (editorData) => {
    const current = await getExecutiveEditors();
    const newEntry = { id: 'editor_' + Date.now(), ...editorData };
    await saveLocalEditors([...current, newEntry]);
    return newEntry;
  },

  updateEditor: async (id, editorData) => {
    const current = await getExecutiveEditors();
    await saveLocalEditors(current.map(e => e.id === id ? { ...e, ...editorData } : e));
    return { id, ...editorData };
  },

  deleteEditor: async (id) => {
    const current = await getExecutiveEditors();
    await saveLocalEditors(current.filter(e => e.id !== id));
    return { id };
  }
};
